import React from 'react';


class StoreForDeliverySelector extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            isEditing: false,
            storeForDeliveryGln: this.props.store.storeForDelivery ? this.props.store.storeForDelivery.gln : ''
        };
        this.edit = this.edit.bind(this);
        this.cancel = this.cancel.bind(this);
        this.delete = this.delete.bind(this);
        this.change = this.change.bind(this);
        this.commit = this.commit.bind(this);
    }

    edit() {
        if( this.props.options.length === 0) return;
        this.setState({isEditing: true})
    }

    cancel() {
        this.setState({isEditing: false});
    }

    delete() {
        this.props.onCommit('');
        this.setState({isEditing: false});
    }

    change(event) {
        this.setState({storeForDeliveryGln: event.target.value});
    }

    commit() {
        this.props.onCommit(this.state.storeForDeliveryGln);
        this.setState({isEditing: false});
    }

    componentWillReceiveProps(nextProps) {
        if (this.state.isEditing) return;

        if (nextProps.storeForDelivery === this.state.storeForDelivery) return;

        this.setState({
            isEditing: false
        });
    }

    render() {
        if (this.state.isEditing) {
            return (
                <div style={{width: '250px'}}>
                    <div className="input-group">
                        <select name="select"
                                id="select"
                                className="form-control form-control-sm"
                                value={this.state.storeForDeliveryGln}
                                onChange={this.change}>
                            <option key="" value="">Bitte wählen</option>
                            {this.props.options.map(option => {
                                return <option key={option.id} value={option.id}>{option.label}</option>
                            })}
                        </select>
                        <div className="input-group-btn">
                            <button className="btn btn-sm btn-success" onClick={this.commit}>
                                <i className="fa fa-check"/>
                            </button>
                            <button className="btn btn-sm btn-secondary" onClick={this.cancel}>
                                <i className="fa fa-times"/>
                            </button>
                        </div>
                    </div>
                </div>
            )
        }

        if (!this.props.store.storeForDelivery) {
            return (
                <div style={{width: '250px', height: '21px'}} onClick={this.edit}>
                </div>
            );
        }

        return (
            <div style={{width: '250px', height: '21px'}}>
                <span onClick={this.edit}>{this.props.store.storeForDelivery.city} ({this.props.store.storeForDelivery.gln})</span>
                &nbsp;<span onClick={this.delete}><i className="fa fa-trash"/></span>
            </div>
        );
    }
}

export default StoreForDeliverySelector;



// WEBPACK FOOTER //
// ./src/admin/retailer/StoreForDeliverySelector.js